import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useSummarySectionStyles = makeStyles(() => ({
  summaryGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing.md,
    marginBottom: spacing.lg,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: '1fr 1fr',
      gap: spacing.md,
    },
  },
  summaryCard: {
    backgroundColor: colors.white,
    borderRadius: radius.md,
    padding: spacing.lg,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.lg,
  },
  summaryCardTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    lineHeight: 'normal',
  },
  sideCardsStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
  },
  detailsSection: {
    marginTop: spacing.lg,
  },
  detailsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing.lg,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
}));
